import { ITag } from "@gtmhub/tags";
import { Assignee } from "@webapp/assignees/models/assignee.models";
import { CfMap } from "@webapp/custom-fields/models/custom-fields.models";
import { Links } from "@webapp/links/models/links.models";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { IAccess } from "@webapp/sessions/models/sessions.model";
import { Task } from "@webapp/tasks/models/tasks.models";
import { IDesignScore } from "./goal-design-score.models";
import { IOkrClosedStatus } from "./goal-status.models";
import { IItemWorkflow } from "./goal-workflow.models";

interface IBaseGoal {
  id: string;
  name: string;
}

export class Goal implements IBaseGoal {
  public id!: string;
  public name!: string;
  public description?: string;
  public ownerIds!: string[];
  public assignees: Assignee[];
  public sessionId: string;
  public dateTo?: string;
  public dateFrom?: string;
  public closedStatus?: IOkrClosedStatus;
  public parentId?: string;
  public parentType?: GoalParentType;
  public parentGoalSessionId?: string;
  public metrics?: Metric[];
  public metricsCount?: number;
  public tasks?: Task[];
  public tasksCount?: number;
  public nonArchivedTasksCount?: number;
  public childrenCount?: number;
  public fullSubTreeCount?: number;
  public attainment: number;
  public attainmentTypeString: AttainmentTypeString;
  public aggregatedAttainment?: number;
  public fullAggregatedAttainment?: number;
  public obfuscated: boolean;
  public private: boolean;
  public locked: boolean;
  public tags?: ITag[];
  public customFields?: CfMap;
  public access?: IAccess;
  public designScore?: IDesignScore;
  public links?: Links<"goal">;
  public workflow?: IItemWorkflow;
  public orderId?: number;
  public childType?: "goal";
  public color?: string;
}

export class GoalDTO {}

export type GoalParentType = "goal" | "metric";

export type AttainmentTypeString = "average_kr" | "average_children" | "average_children_kr";
